<template>
  <v-container fluid class="rbu-admin-detail" v-if="volume">
    <v-row class="flex-grow-0">
      <v-btn
        text
        x-small
        color="primary"
        exact
        :to="{
          name: 'rbu-volume-detail',
          params: {
            volumeId: volume.id,
          },
        }"
      >
        &lt;&lt; Back to RBU Volume
      </v-btn>
    </v-row>

    <v-row v-if="edition" class="rbu-admin-info-wrapper">
      <h3>{{ `Edition: ${edition.edition} - ${edition.name}` }}</h3>
      <h3>{{ `Volume: ${volume.name}` }}</h3>
    </v-row>

    <v-row class="admin-detail-row mt-8 rounded-t">
      <v-col cols="12" class="d-flex" style="align-items: center">
        <span class="font-weight-bold">{{ `RBU User` }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="canAddRbuAdmin"
          @click="addRbuAdmin"
        >
          Add RBU User
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-0 rounded-b">
      <RbuAdminList
        :volume-id="$route.params.volumeId"
        :refresh-trigger.sync="rbuAdminRefreshTrigger"
      ></RbuAdminList>
    </v-row>
  </v-container>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import RbuAdminList from "@/components/rbu/RbuAdminsList.vue";
import SelectAccountDialog from "@/components/SelectAccountDialog";

export default {
  name: "RbuAdmins",
  components: {
    RbuAdminList,
  },
  setup(props, { root }) {
    const volume = ref(null);
    const edition = ref(null);
    const rbuAdminRefreshTrigger = ref(false);

    const canAddRbuAdmin = computed(() => {
      const user = root.$store.getters.account;
      if (user && ["SUPER_ADMIN", "ADMIN"].includes(user.type)) {
        return true;
      }
      return false;
    });

    const getVolume = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/volume/",
        params: { volume_id: root.$route.params.volumeId },
      });

      if (response.body.success) {
        volume.value = response.body.volume;
      }
    };

    const getEdition = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/edition/",
        params: { edition_id: root.$route.params.editionId },
      });

      if (response.body.success) {
        edition.value = response.body.edition;
      }
    };

    const addRbuAdmin = async function () {
      const account = await root.$dialog.showAndWait(SelectAccountDialog, {
        title: "Add Rbu Volume Admin",
        showClose: false,
        persistent: true,
        width: "640px",
      });

      if (account) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/volume/admin_create/",
          params: {
            volume_id: root.$route.params.volumeId,
            account_id: account.id,
          },
        });

        if (response.body.success) {
          rbuAdminRefreshTrigger.value = true;
        }
      }
    };

    onMounted(async () => {
      await root.$store.dispatch(ACTION_TYPES.GET_ME);
      getEdition();
      getVolume();
    });
    return {
      volume,
      edition,
      canAddRbuAdmin,
      rbuAdminRefreshTrigger,
      addRbuAdmin,
    };
  },
};
</script>

<style lang="less">
.rbu-admin-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rbu-admin-info-wrapper {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;

    .rbu-admin-info {
      flex: 1 1 0;
    }
  }

  .admin-detail-row {
    flex: 0 0 auto;
    background-color: #ffffff;

    &.finalised {
      background-color: #ffffff88;
    }
  }
}
</style>
